<template>
  <div>
    <vs-tabs v-model="tabIndex">
      <vs-tab v-for="tab of tabList" :key="tab.name" :label="tab.label" @click="onClickTab(tab)" />
    </vs-tabs>

    <!-- search -->
    <search-nav @handleSearch="onClickSearch">
      <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex ">
        <component
          v-for="(component, index) in stdSearchComponents"
          v-if="showSearchNavItem(component['options'])"
          :key="index"
          :is="component['component']"
          :label="component['label']"
          :query="component['query']"
          :options="component['options']"
          :onClickSearch="onClickSearch"
          v-model="nav.value[component['value']]"
        />
      </div>
    </search-nav>

    <!-- list -->
    <div>
      <fragment>
        <div class="w-full flex">
          <div class="flex mr-auto mb-4">
            <vs-select v-model="perPage" autocomplete class="mr-4" style="width: 110px;" >
              <vs-select-item v-for="v in [10, 20, 30, 50]" :key="v" :text="`${v}개씩 보기`" :value="v" />
            </vs-select>
          </div>
        </div>
      </fragment>
      <div class="w-full overflow-x-auto">
        <div class="list">
          <div class="list-header list-grid">
            <div>No.</div>
            <div>사업장명</div>
            <div>업체명</div>
            <div>담당부서</div>
            <div>아이디</div>
            <div>내국인/외국인</div>
            <div>직책</div>
            <div>이름</div>
            <div>직종</div>
            <div>신청일</div>
            <div>상태</div>
          </div>
          <div class="list-body">
            <div v-for="(data, index) in paginationList" :key="index"
                 class="list-grid"
                 @click="onClickItem(data)">
              <template>
                <div>{{ getItemNumber(index) }}</div>
                <div>{{ data.field? data.field.field_name : '' }}</div>
                <div>{{ data.업체? data.업체.com_name : '' }}</div>
                <div>{{ data.담당부서 }}</div>
                <div>{{ data.username }}</div>
                <div>{{ data.foreign }}</div>
                <div>{{ data.직책 }}</div>
                <div>{{ data.name }}</div>
                <div>{{ data.직종 }}</div>
                <div>{{ formatDate(data.created_at) }}</div>
                <div :style="{ color: data.registered_at? '#28C76F':'#EA5455'}">{{ data.registered_at ? '승인' : '거절' }}</div>
              </template>

            </div>
          </div>
        </div>
      </div>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="lastPage ? lastPage : 0" v-model="page"></k-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SearchNav from "@/components/nav/SearchNav.vue";
import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import List from "@/views/boards/single-page/980/List.js";
import searchComponent from "@/views/list/components/include";
import KPagination from "@/components/kPagination/kPagination.vue";
import HttpRequest from "@/util/HttpRequest";

export default {
  components: {
    KPagination,
    FieldSelector,
    SearchColumnKeyword,
    SearchNav
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
    mode: {
      type: String,
      default: "list"
    }
  },
  computed: {
    tabList() {
      const list = [
        { code: 0, name: "page-standing-account-list", label: "회원가입 대기 목록", },
        { code: 1, name: "page-confirm-account-list", label: "회원가입 승인 목록", }
      ];
      return list;
    },
    projectId() {
      return this.$route.params.proj_id;
    },

    stdSearchComponents() {
      const getComponents = List.components
      if (getComponents) {
        // 중복제거 코드 : filter((value, index, self) => self.indexOf(value) === index)
        const stdSearchComponents = getComponents();
        if (stdSearchComponents && stdSearchComponents.length > 0) {
          for (const component of stdSearchComponents) {
            component.component = searchComponent[component['component']];
          }
        }
        return stdSearchComponents;
      }
      return [];
    },
    paginationList () {
      return this.allList;
    },
    // 검색된 목록
    searchedList () {
      return this.allList;
    }
  },
  watch : {
    perPage() {
      if (!this.isLoadingFromQuery) {
        this.page = 1;
      }
      this.loadListBoardAll();
      this.updateQueryParams();
    },
    page() {
      this.loadListBoardAll();
      this.updateQueryParams();
    },
    '$route.query': {
      handler(newQuery) {
        this.loadStateFromQuery(newQuery);
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      tabIndex: 1,
      nav: {
        value: {},
        options: {
          사업장명: [],
          상태: [],
        }
      },
      page: 1,
      lastPage: 1,
      perPage: 10,
      total: 0,
      allList:[],
      isLoadingFromQuery: false,

      form: {
        사업장명: {},
        팀명: '',
        공장명: '',
        대분류: '',
        중분류: '',
        소분류: '',
      },
      search: {},
    };
  },
  created() {
    this.initBreadcrumb();
    this.isLoadingFromQuery = true; // 초기 로드 시 플래그 설정
    this.loadStateFromQuery(this.$route.query);
    this.loadListBoardAll();
    this.updateQueryParams();
    this.$nextTick(() => {
      this.isLoadingFromQuery = false; // 초기 로드 완료 후 플래그 해제
    });
  },
  methods: {
    initBreadcrumb () {
      this.$store.commit('menu/UPDATE_PAGE_LIST', [{title: 'Home'}, {title: '작업자 관리'}, {title: '회원가입 신청 현황', active: true}])
    },
    onClickTab(tab) {
      this.tabIndex = tab.code;
      this.$router.push({ name: tab.name });
    },
    showSearchNavItem(options) {
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.nav.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },
    async loadListBoardAll () {
      const conditions = List.getConditions(this.nav);
      const params = {
        page: this.page,
        perPage: this.perPage,
        status: 'apprej',
      };

      conditions.forEach(condition => {
        if (condition.value !== '') {
          params[condition.key] = condition.value;
        }
      });

      try {
        const response = await HttpRequest.get('/api/v1/user/pending', { params });

        if (response && response.data) {
          this.allList = response.data.map((data) => {
            return {
              id: data.id,
              username: data.username,
              name: data.name_masked,
              phone: data.phone_masked,
              email: data.email_masked,
              foreign: data.is_foreigner ? '외국인' : '내국인',
              registered_at: data.registered_at,
              rejected_at: data.rejected_at,
              created_at: data.created_at,
              updated_at: data.updated_at,
              ...(data.meta)
            };
          });
          this.lastPage = response.last_page;
          this.total = response.total;
        } else {
          console.error("Response or response.data is undefined");
        }
      } catch (err) {
        console.error("Error fetching data", err);
      }
    },

    onClickSearch () {
      this.page = 1;
      this.loadListBoardAll();
      this.updateQueryParams();
    },

    onClickItem (data) {
      this.$router.push({
        name: 'page-confirm-account-detail',
        params: { proj_id: this.projectId, id: data.id },
        query: this.$route.query
      });
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    getItemNumber(index) {
      return this.total - ((this.page - 1) * this.perPage) - index;
    },

    updateQueryParams() {
      const query = { ...this.$route.query };

      // 페이지 번호 설정
      query.page = this.page.toString();
      query.perPage = this.perPage.toString();

      // 검색 조건 설정
      if (this.nav.value && this.nav.value.column) {
        if (this.nav.value.column.head) {
          query.ck_t = this.nav.value.column.head;
        } else {
          delete query.ck_t;
        }

        if (this.nav.value.column.keyword) {
          query.ck_k = this.nav.value.column.keyword;
        } else {
          delete query.ck_k;
        }

        if (this.nav.value.field && this.nav.value.field.fieldId) {
          query.f_id = this.nav.value.field.fieldId;
          query.f_name = this.nav.value.field.fieldName;
        } else {
          delete query.f_id;
          delete query.f_name;
        }
      } else {
        delete query.ck_t;
        delete query.ck_k;
        delete query.f_id;
        delete query.f_name;
      }

      // 현재 URL과 다른 경우에만 라우터 변경
      const currentQuery = JSON.stringify(this.$route.query);
      const newQuery = JSON.stringify(query);

      if (currentQuery !== newQuery) {
        this.$router.replace({ query }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },

    loadStateFromQuery(query) {
      if (!query) return;

      this.isLoadingFromQuery = true; // URL에서 로드 중임을 표시

      // 페이지 번호와 페이지당 항목 수 복원
      if (query.page) {
        this.page = parseInt(query.page) || 1;
      }

      if (query.perPage) {
        this.perPage = parseInt(query.perPage) || 10;
      }

      // 검색 조건 복원
      if (query.ck_t || query.ck_k || query.f_id || query.f_name) {
        if (!this.nav.value.column) {
          this.nav.value.column = {};
        }

        if (query.ck_t) {
          this.nav.value.column.head = query.ck_t;
        }

        if (query.ck_k) {
          this.nav.value.column.keyword = query.ck_k;
        }

        if (query.f_id) {
          this.nav.value.field = {
            fieldId: query.f_id,
            fieldName: query.f_name
          };
        } else {
          this.nav.value.field = {
            fieldId: "",
            fieldName: ""
          };
        }
      }

      // 다음 tick에서 플래그 해제 (모든 watcher 실행 완료 후)
      this.$nextTick(() => {
        this.isLoadingFromQuery = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  text-align: center;

  .list-header {
    font-weight: 700;
    & > div {
      background-color: #f5f5f5;
      border-top: 1px solid #e0e0e0;
      border-bottom: 1px solid #e0e0e0;
    }
  }
  .list-body {

    & > div > div { background-color: #ffffff; border-bottom: 1px solid #e0e0e0; }
    & > div:hover { background-color: #f5f5f5; color: #000; font-weight: bold }
    & > div.active { background-color: #7E72F299; color: #fff }
  }

  .list-grid {
    display: grid;
    grid-template-columns: 60px repeat(10, minmax(140px, 1fr));

    & > div {
      padding: 10px 4px;
      justify-content: center;
      align-content: center;
    }
  }
  .list-edit {
    display: none;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }
}
</style>
